import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=eebf15b6&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=eebf15b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eebf15b6",
  null
  
)

export default component.exports